<template>
  <div class="body">
    <div class="common-page dark-theme">
      <div class="wrap">
        <h1 class="logo">
          <a href="/index.html">
            <img src="../../assets/images/common/ci-wavve.png" alt="wavve" />
          </a>
        </h1>
      </div>
      <div v-if="profileInfo && imageList" class="tAc">
        <h2>프로필 수정</h2>
        <div class="user-wrap01">
          <div class="user-style">
            <div class="user-img">
              <img :src="url(image)" :alt="imageAlt"/>
            </div>
          </div>
        </div>
        <a href="#" v-if="!isProfileImageView" @click.prevent="setProfileImg()" class="img-edit">프로필 이미지 변경</a>
        <div v-if="profileInfo.multiprofile === 'y'" class="profile-wrap02">
          <label for="name-change">이름변경</label>
          <input id="name-change" type="text" v-model="name" class="input-style01 dark-theme"/>
        </div>
        <ul v-if="isProfileImageView" class="profile-wrap01">
        <!-- 현재 선택된 프로필 이미지인 경우에는 selected 클래스를 넣어주세요.-->
          <li v-for="(imageInfo, index) in imageList" :key="index" class="profile-style">
            <a href="#" @click.prevent="setSelectImg(imageInfo)">
              <img :src="url(imageInfo.image)" :alt="imageInfo.alt"/>
              <span :class="getSelectImgCss(imageInfo.image)">체크</span>
            </a>
          </li>
        </ul>
        <ul class="common-btn-wrap">
          <div class="btn-gray-line">
            <a href="#" @click.prevent="getConfirmUrl()">취소</a>
          </div>
          <div class="btn-purple btn-purple-dark">
            <a href="#" @click.prevent="updateProfile()">확인</a>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { postProfilesDetail, getProfilesDetail, getProfilesImages } from '@/common/utils/request'
import { changeReferer } from '@/common/utils/common'
import cookie from '@/common/utils/cookie'
import _ from 'lodash'
export default {
  data () {
    return {
      id: 0,
      pageType: '',
      referer: '',
      name: '',
      nameByte: 0,
      selectedImageId: '',
      profileInfo: {},
      image: '',
      imageAlt: '',
      imageList: [],
      imageId: 'none',
      imageUrl: '',
      isProfileImageView: false
    }
  },
  watch: {
    name () {
      let len = 0
      for (let i = 0; i < this.name.length; i++) {
        if (escape(this.name.charAt(i)).length === 6) {
          len++
        }
        len++
        this.nameByte = len
        if (this.nameByte > 50) {
          alert('프로필명은 최대 50Byte 까지 설정 가능합니다.')
          this.name = this.name.substring(0, i)
          return
        }
      }
    }
  },
  methods: {
    url (url) {
      return location.protocol + '//' + url
    },
    getConfirmUrl () {
      if (this.pageType === 'memberSelect' || this.profileInfo.multiprofile === 'y') {
        this.$router.push('/member/profile_change')
      } else {
        this.$router.replace(changeReferer(this.referer))
      }
    },
    getSelectImgCss (image) {
      return this.image === image ? 'check-on' : ''
    },
    setSelectImg (image) {
      this.imageId = image.imageid
      this.image = image.image
      this.imageAlt = _.get(image, 'alt', '')
      this.imageList.forEach(data => {
        if (data.imageid === this.imageId) {
          this.imageUrl = data.image
        }
      })
    },
    setProfileImg () {
      this.isProfileImageView = true
    },
    updateProfile () {
      if (this.name.length === 0 || !this.name) { alert('이름을 입력해 주세요.'); return }
      this.imageId = _.get(this.imageList.filter(imageItem => imageItem.image === this.image), [0, 'imageid'], '')
      if (this.nameByte > 50) {
        alert('프로필명은 최대 50Byte 까지 설정 가능합니다.')
        return
      }
      postProfilesDetail({ profileid: this.id, imageid: this.imageId, profilename: this.name })
        .then((response) => {
          const profile = _.get(_.filter(response, profile => profile.profileid === this.id), ['0'],
            { image: this.imageUrl, profilename: this.name })
          const { image, profilename } = profile
          cookie.changeUserInfo(profilename, image)
          this.image = image
          this.selectedImageId = this.imageId
          this.isProfileImageView = false
          this.getConfirmUrl()
        })
    },
    setData () {
      if (this.id) {
        getProfilesDetail({ profileid: this.id }).then(({ data }) => {
          this.profileInfo = data
          this.image = _.get(data, 'image', '')
          this.imageAlt = _.get(data, 'alt', '')
          this.name = _.get(data, 'profilename', '')
          this.imageUrl = _.get(data, 'image', '')
        })

        // 프로필 이미지 변경 리스트
        getProfilesImages({ offset: 0, limit: 30, orderby: 'old' }).then(({ data }) => {
          this.imageList = _.get(data, 'list', [])
        })
      }
    }
  },
  created () {
    this.id = _.get(this.$route, ['query', 'profileId'], 0)
    this.pageType = _.get(this.$route, ['query', 'pageType'], '')
    this.referer = _.get(this.$route, ['query', 'referer'], '/index.html')
    this.setData()
  }
}
</script>
<style lang="css" src="@/assets/css/main.css"></style>
